import { MAP_TYPES } from '@deck.gl/carto';

const LANDSURFACETEMPERATURE_SOURCE_ID = 'landSurfaceTemperatureSource';

const source = {
  id: LANDSURFACETEMPERATURE_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.Land_Surface_Temperature`,
};

export default source;
